var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSide1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 534,
    viewBox: "0 0 267 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M4.06107 322.034L12.7129 330.595M235.542 533L152.29 457.786V406.421L91.374 350.163H32.4886L12.7129 330.595M12.7129 330.595L32.4886 312.251L59.5623 330.595H115.064M4.06107 289.625H59.5623L78.514 304.913H146.198L163.12 322.034M0 262.72H23.0127L33.9669 253.547M221.328 268.834H157.705L125.216 239.483H50.7634L33.9669 253.547M4.06107 223.584H23.0127L32.4886 210.743H50.7634L68.3613 227.253H125.216L152.29 201.92M163.12 191.786L152.29 201.92M152.29 201.92L170.565 218.692M12.7129 183.225H46.0254L68.3613 204.016H91.374M2.03053 190.563L31.1349 163.657L99.4962 163.046L115.064 148.37L142.137 123.91L266 123.299M33.9669 253.547L50.7634 268.834H108.295M68.3613 160.6L106.265 126.356V111.069M199.669 1L106.265 85.9977V111.069M106.265 111.069L146.198 75.6023H217.944M46.0254 160.6V140.421",
    stroke: "url(#paint0_linear_61_1094)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1094",
    x1: 0,
    y1: 267,
    x2: 266,
    y2: 267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4290",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4290",
    stopOpacity: 0.04
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide1);
export default __webpack_public_path__ + "static/media/side1.d96690f1b2fdda81ec466d07cb53f2d3.svg";
export { ForwardRef as ReactComponent };